import {DatePickerInput} from '@mantine/dates';
import classes from './date-picker-input.module.css';

export const DatePickerInputTheme = DatePickerInput.extend({
  classNames: {
    day: classes.day,
  },
});